import React from 'react';
import PropTypes from 'prop-types';

const MobileExplanations = ({ recommendationMessage, recommendationTitle }) => (
  <section className="mobile-financial-plan-explanations-section-no-tabs">
    <h4 className="mobile-financial-plan-explanations-section-title">{recommendationTitle}</h4>
    <p className="mobile-financial-plan-explanations-section-message">{recommendationMessage}</p>
  </section>
);

MobileExplanations.propTypes = {
  recommendationMessage: PropTypes.string.isRequired,
  recommendationTitle: PropTypes.string.isRequired,
};

export default MobileExplanations;
